var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.516,
    height: 29.314,
    viewBox: "0 0 40.51632 29.313901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.635 0l-.674 1.93 6.103 1.88C18.053 3.312 2.26 12.61 0 29.313l2.114-.068C4.504 13.418 18.04 5.698 34.867 5.438l-5.673 2.82.99 1.664 10.332-5.39z",
    fill: "red",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.2db5cadb06a173cddf58cbc2c15101b1.svg";
export { ForwardRef as ReactComponent };